import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-modal-approved',
  templateUrl: './modal-approved.component.html',
  styleUrls: ['./modal-approved.component.scss'],
})
export class ModalApprovedComponent {
  @Output() closeModalPlan = new EventEmitter();
  @Output() nextStatus = new EventEmitter<{
    status: string;
    motivo: string;
  }>();
  
  comentario: string = '';

  closeModal() {
    this.closeModalPlan.emit(false);
  }

  savedRequest() {
    const motivo = this.comentario;
    const status = 'Aprobada';
    this.nextStatus.emit({ status, motivo });
    this.closeModalPlan.emit(false);
  }
}
